export const userList = [
    {name:'David Vuitton', description:'plymout - avilation and aerospace', position:'Designer', avatar:'/assets/images/faces/11.png', follow:true, active:true},
    {name:'Leila Vuitton', description:'San Fransisco, USA - Silicon Valley', position:'Program Manager', avatar:'/assets/images/faces/12.png', follow:false, active:true},
    {name:'Martin Vuitton', description:'Nytimes', position:'Writer', avatar:'/assets/images/faces/13.png', follow:true},
    {name:'Alisson Vuitton', description:'SpaceX', position:'Astronaute', avatar:'/assets/images/faces/14.png', follow:true, active:true},
    {name:'Leisson Vuitton', description:'Nevada', position:'Farmer', avatar:'/assets/images/faces/15.png', follow:false},
]

export const onlineUsers = [
    { avatar:'1', name:'Omar' },
    { avatar:'17', name:'Hasan' },
]

export const offlineUsers = [
    { avatar:'3', name:'Ahmad', active:true },
    { avatar:'8', name:'Muhammad', active:true },
    { avatar:'11', name:'Kareem' },
    { avatar:'10', name:'Faruq', active:true },
    { avatar:'13', name:'Abu Baqr' },
    { avatar:'9', name:'Ali' },
    { avatar:'6', name:'Mahmood' },
]